import { useState } from 'react';
import { mockTodos } from '@/mocks/userData';

export default function TodoList() {
  const [todos, setTodos] = useState(mockTodos);

  const toggle = (id: string) => {
    setTodos(prev => prev.map(t => t.id === id ? { ...t, done: !t.done } : t));
  };

  return (
    <div className="px-4 mb-4">
      <div className="flex items-center justify-between mb-2">
        <span className="font-semibold text-sm" style={{ color: '#3D3D3D' }}>今日待办</span>
        <button className="text-xs cursor-pointer whitespace-nowrap" style={{ color: '#C5B9D8' }}>查看全部</button>
      </div>
      <div
        className="rounded-2xl overflow-hidden"
        style={{
          background: 'rgba(255,255,255,0.72)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.7)',
        }}
      >
        {todos.slice(0, 3).map((todo, i) => (
          <div key={todo.id}>
            <div className="flex items-center gap-3 px-4 py-3">
              <button
                onClick={() => toggle(todo.id)}
                className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 cursor-pointer transition-all active:scale-90"
                style={{
                  border: todo.done ? 'none' : '1.5px solid rgba(181,198,224,0.6)',
                  background: todo.done ? 'linear-gradient(135deg,#B5C6E0,#C5B9D8)' : 'transparent',
                }}
              >
                {todo.done && <i className="ri-check-line text-white" style={{ fontSize: 11 }} />}
              </button>
              <span
                className="flex-1 text-sm"
                style={{
                  color: todo.done ? '#B0B0B0' : '#3D3D3D',
                  textDecoration: todo.done ? 'line-through' : 'none',
                }}
              >
                {todo.text}
              </span>
            </div>
            {i < todos.slice(0, 3).length - 1 && (
              <div className="mx-4 h-px" style={{ background: 'rgba(181,198,224,0.15)' }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
